import { useCallback } from "react";
import { getAllCitiesStats } from "@/services/seo/allCitiesStatsService";
import { persistentCache } from "@/lib/cache/persistentCache";
import { debugLog } from "@/utils/debugLogger";
import { CACHE_TTL, ttlToHours } from "@/lib/cache/cacheConfig";

const CACHE_KEY = 'cities_stats_data_v2'; // Aligned with useAllCitiesStats
// USA costante centralizzata invece di hardcoded 0.5 ore
const CACHE_TTL_HOURS = ttlToHours(CACHE_TTL.CLIENT_CITIES_STATS); // 30 minuti

/**
 * Hook per prefetch intelligente dei dati delle città
 * Implementa cache persistente e strategia di prefetch su hover
 */
export function useCitiesStatsPrefetch() {
  
  const prefetchCitiesStats = useCallback(async () => {
    try {
      // Controlla se i dati sono già in cache
      const cachedData = persistentCache.get(CACHE_KEY);
      if (cachedData) {
        debugLog('general', 'Cities stats già in cache, prefetch skippato', undefined, 'useCitiesStatsPrefetch');
        return cachedData;
      }

      debugLog('general', 'Avvio prefetch cities stats', undefined, 'useCitiesStatsPrefetch');
      
      // Fetch dei dati freschi
      const citiesStats = await getAllCitiesStats();
      
      // Salva in cache persistente
      persistentCache.set(CACHE_KEY, citiesStats, CACHE_TTL_HOURS);
      
      debugLog('general', `Prefetch completato per ${citiesStats.length} città`, undefined, 'useCitiesStatsPrefetch');
      
      return citiesStats;
    } catch (error) {
      debugLog('general', 'Errore durante prefetch cities stats', error, 'useCitiesStatsPrefetch');
      return null;
    }
  }, []);

  const getCachedCitiesStats = useCallback(() => {
    return persistentCache.get(CACHE_KEY);
  }, []);

  return {
    prefetchCitiesStats,
    getCachedCitiesStats
  };
}